/* eslint-disable */
// Zero-touch integration for upstream `theme.js`:
// - Loads before theme.js
// - Intercepts add-to-cart click/submit events in capture phase
// - Runs custom validation; blocks event when invalid
// - Otherwise does nothing and lets theme.js run normally

(function (root, factory) {
  if (typeof module !== "undefined" && module.exports) {
    module.exports = factory();
  } else {
    const api = factory();
    // Bind immediately (scripts are `defer`, so DOM is parsed already)
    api.bindProductAddValidation({
      document: root.document,
      validate: function ({ form }) {
        const custom = root.themeCustomValidation;
        if (!custom || typeof custom.validateProductAdd !== "function") return true;
        return !!custom.validateProductAdd({ form });
      },
    });
  }
})(typeof window !== "undefined" ? window : globalThis, function () {
  function isAddToCartButton(el) {
    if (!el) return false;
    const name =
      (typeof el.getAttribute === "function" && el.getAttribute("name")) || el.name;
    if (String(name || "").toLowerCase() === "add") return true;
    if (typeof el.getAttribute === "function" && el.getAttribute("data-add-to-cart") != null)
      return true;
    return false;
  }

  function resolveButtonFromTarget(target) {
    if (!target) return null;
    if (target.tagName === "BUTTON") return target;
    if (typeof target.closest === "function") {
      try {
        return target.closest("button");
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  function resolveFormFromButton(documentRef, button) {
    if (!button) return null;
    if (button.form) return button.form;
    if (typeof button.getAttribute === "function") {
      const formId = button.getAttribute("form");
      if (formId && documentRef && typeof documentRef.getElementById === "function") {
        const el = documentRef.getElementById(formId);
        if (el) return el;
      }
    }
    if (typeof button.closest === "function") {
      try {
        return button.closest("form");
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  function shouldInterceptClick(documentRef, evt) {
    const button = resolveButtonFromTarget(evt && evt.target);
    if (!button) return { should: false, form: null };
    if (!isAddToCartButton(button)) return { should: false, form: null };
    const form = resolveFormFromButton(documentRef, button);
    return { should: true, form };
  }

  function bindProductAddValidation(options) {
    const opts = options || {};
    const documentRef = opts.document;
    const windowRef = opts.window || (typeof window !== "undefined" ? window : null);
    const validate =
      typeof opts.validate === "function"
        ? opts.validate
        : function () {
            return true;
          };

    if (!documentRef || typeof documentRef.addEventListener !== "function") return;
    if (documentRef.__themeCustomValidationProductAddBound) return;
    documentRef.__themeCustomValidationProductAddBound = true;

    documentRef.addEventListener(
      "click",
      function (evt) {
        const ctx = shouldInterceptClick(documentRef, evt);
        if (!ctx.should) return;
        if (windowRef && windowRef.themeCustomValidation) {
          windowRef.themeCustomValidation.__lastAddToCartForm = ctx.form || null;
        }
        const ok = validate({ form: ctx.form });
        if (ok) return;
        if (evt && typeof evt.preventDefault === "function") evt.preventDefault();
        if (evt && typeof evt.stopImmediatePropagation === "function")
          evt.stopImmediatePropagation();
      },
      { capture: true }
    );

    documentRef.addEventListener(
      "submit",
      function (evt) {
        const form = evt && evt.target ? evt.target : null;
        if (!form) return;
        const action =
          (typeof form.getAttribute === "function" && form.getAttribute("action")) ||
          form.action ||
          "";
        const isCartAdd =
          typeof action === "string" &&
          (action.indexOf("/cart/add") !== -1 || action.indexOf("cart/add") !== -1);
        if (!isCartAdd) return;

        if (windowRef && windowRef.themeCustomValidation) {
          windowRef.themeCustomValidation.__lastAddToCartForm = form;
        }
        const ok = validate({ form });
        if (ok) return;
        if (evt && typeof evt.preventDefault === "function") evt.preventDefault();
        if (evt && typeof evt.stopImmediatePropagation === "function")
          evt.stopImmediatePropagation();
      },
      { capture: true }
    );
  }

  return { bindProductAddValidation };
});
